import { MenuProps } from 'antd';
import React, { useState } from 'react';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { withTheme } from '../ThemeProvider';
import {
  StyledItemLabel,
  StyledNavigationMenu,
  StyleNavigationMenuHeader,
  StyleNavigationMenuWrapper,
} from './styles';
import { MenuItem, NavigationMenuProps } from './types';

const NavigationMenuComponent: React.FC<NavigationMenuProps> = ({
  items = [],
  categoryLabel = 'Category',
  defaultOpenKeys = [],
  defaultSelectedKeys = [],
  ...props
}) => {
  const [collapsed, setCollapsed] = useState<boolean>(false);

  const renderItems = (items: MenuItem[]): MenuProps['items'] =>
    items.map(it => ({
      key: it.key,
      icon: it.icon,
      label: (
        <StyledItemLabel>
          <span>{it.label}</span>
          {it.actionIcon && <span className="action">{it.actionIcon}</span>}
        </StyledItemLabel>
      ),
      children: it.children && renderItems(it.children),
    }));

  return (
    <StyleNavigationMenuWrapper>
      <StyleNavigationMenuHeader>
        <span>{categoryLabel}</span>
        <button
          onClick={() => setCollapsed(!collapsed)}
          style={{ cursor: 'pointer', background: 'none', border: 'none' }}
          aria-label={collapsed ? 'Expand menu' : 'Collapse menu'}
        ></button>
      </StyleNavigationMenuHeader>
      <StyledNavigationMenu
        mode="inline"
        expandIcon={({ isOpen }) => (isOpen ? <IoIosArrowUp /> : <IoIosArrowDown />)}
        items={renderItems(items)}
        inlineCollapsed={collapsed}
        defaultOpenKeys={defaultOpenKeys}
        defaultSelectedKeys={defaultSelectedKeys}
        {...props}
      />
    </StyleNavigationMenuWrapper>
  );
};

export const NavigationMenu = withTheme(NavigationMenuComponent);
export default NavigationMenu;
